import styled from 'styled-components';

export const StyledSettingsSidebar = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 24px 24px;
  overflow-y: auto;
  border-left: 1px solid #c6c6c6;
  z-index: 1;
`;

export const StyledSettings = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 270px;
`;

export const ChevronIcon = styled.div<{ readonly $isOpen: boolean }>`
  color: #b2b1ba;
  transition: transform 0.2s ease;
  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(0deg)' : 'rotate(-90deg)')};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledSettingsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
